import React from 'react';
import { AdsList } from './AdsList';

/**
 * Main Ad Management Component
 *
 * This component serves as the main entry point for the Ad Management system,
 * providing a complete interface for:
 * - Creating, editing, and deleting ads
 * - Managing tracking settings
 * - Viewing analytics and performance metrics
 * - Copying tracking URLs
 */
export const AdManagement: React.FC = () => {
  return (
    <div className='min-h-screen bg-gray-50'>
      {/* Main Container */}
      <div className='container mx-auto px-4 py-8'>
        <AdsList />
      </div>
    </div>
  );
};
